import { useEffect } from 'react';

import { useSession } from '@eneco/auth';

import { FlowContext } from '../types';
import { useFlowHooks } from './FlowProvider';

// Shared by flows that gate steps behind login and redirect to /inloggen/ otherwise; isAuthenticated
// lives on the base FlowContext, so this works regardless of a flow's own context extensions.
export function useFlowAuthenticated() {
  const { useFlowActorRef } = useFlowHooks<FlowContext>();
  const { send: sendToFlowMachine } = useFlowActorRef();
  const { status } = useSession();
  const isAuthenticated = status === 'authenticated';

  useEffect(() => {
    // status is 'loading' right after a refresh even for an authenticated session — only redirect once we know for sure.
    if (status === 'unauthenticated') {
      sendToFlowMachine({
        type: 'UPDATE_ROUTE',
        values: {
          path: '/inloggen/',
        },
      });
    }
  }, [status, sendToFlowMachine]);

  // Keep the machine context in sync so the login step's skipping rule can rely on it
  // (e.g. when navigating via the progress bar) instead of briefly rendering the login step.
  useEffect(() => {
    if (status === 'loading') {
      return;
    }

    sendToFlowMachine({
      type: 'UPDATE_VALUES',
      values: { isAuthenticated },
    });
  }, [isAuthenticated, sendToFlowMachine, status]);

  return { isAuthenticated };
}
